import { render, staticRenderFns } from "./compare-contacts-step.vue?vue&type=template&id=e381667c"
import script from "./compare-contacts-step.vue?vue&type=script&lang=js"
export * from "./compare-contacts-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports